import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FirebaseApp } from 'angularfire2';
import { storage } from 'firebase';

import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-multi-upload-plugin',
  templateUrl: './modal-multi-upload.component.html',
  styleUrls: ['./modal-multi-upload.component.css']
})

export class ModalMultiuploadPluginComponent {

  typeImage = false;
  uploadMode = true;
  fileName: any;
  fileNameArray: any;
  imageChangedEventArray: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  percentage = 0;
  storeRef: storage.Reference;
  archive: any;
  resizeToWidth: number;
  aspectRatio: string;
  horizontal: boolean;
  urlsImage = [];
  urlsVideo = [];
  urlsArchive = [];

  constructor(
    public _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ModalMultiuploadPluginComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    @Inject(FirebaseApp) fb: any
  ) {
    this.storeRef = fb.storage().ref();
    data.type === 'image' ? this.typeImage = true : this.typeImage = false;
    this.resizeToWidth = data.resizeToWidth;
    this.aspectRatio = data.aspectRatio;
    this.horizontal = data.horizontal;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  reset() {
    this.croppedImage = '';
    this.fileName = '';
    this.imageChangedEvent = '';
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCroppedBase64(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    this.cropperReady = true;
  }
  imageLoadFailed() {
    console.log('Load failed');
  }

  UploadImage(event) {
    /*
    console.log(event)
    const files = event.srcElement.files;
    if(files > 0){
      for(let file of files) {
        this.imageChangedEventArray.push(file);
        this.fileNameArray.push(file['name']);
      }
    }  
    */
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        const file = event.target.files[i];
        if (file.type == 'image/jpeg' || file.type == 'image/png' || file.type == 'image/webp' || (file.type && file.type.startsWith('image/'))) {
          var reader = new FileReader();
          reader.onload = async (e: any) => {
            const webpBlob = await this.getWebPBlob(e.target.result);
            const webpUrl = URL.createObjectURL(webpBlob);
            this.urlsImage.push(webpUrl);
          };
          reader.readAsDataURL(file);
        } else if (file.type == 'video/mp4') {
          console.log('aui')

          this.urlsVideo.push(window.URL.createObjectURL(file));
          console.log(this.urlsVideo)
        } else {
          this.fileName = file.name;
          this.urlsArchive.push(file);
        }
        console.log(file);
      }
    }

  }

  getBackground(video) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${video})`);
  }

  getWebPBlob(dataURI: string, quality: number = 0.85): Promise<Blob> {
    return new Promise((resolve) => {
      try {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth || img.width;
          canvas.height = img.naturalHeight || img.height;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.drawImage(img, 0, 0);
            if (canvas.toBlob) {
              canvas.toBlob((blob) => {
                resolve(blob || this.dataURItoBlob(dataURI));
              }, 'image/webp', quality);
              return;
            }
          }
          resolve(this.dataURItoBlob(dataURI));
        };
        img.onerror = () => resolve(this.dataURItoBlob(dataURI));
        img.src = dataURI;
      } catch (e) {
        resolve(this.dataURItoBlob(dataURI));
      }
    });
  }

  dataURItoBlob(dataURI) {
    let type = 'image/png'
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var bb = new Blob([ab], { type: type });
    return bb;
  }

  sendImage() {
    this.getWebPBlob(this.croppedImage).then((imagee: Blob) => {
      const fileName = `${this.uid()}.webp`;
      let caminho = this.storeRef.child('images/' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10) + fileName);
      let tarefa = caminho.put(imagee, { contentType: 'image/webp' });
      tarefa.on('state_changed', (snapshot) => {
        this.percentage = Math.round((tarefa.snapshot.bytesTransferred / tarefa.snapshot.totalBytes) * 100);
      }, error => {
        // Tratar possíveis erros
      }, () => {
        if (tarefa.snapshot.state === 'success') {
          caminho.getDownloadURL().then(url => {
            this.dialogRef.close({ path: url, name: fileName, size: tarefa.snapshot.totalBytes, format: 'image/webp' });
          });
        }
      });
    });
  }

  UploadArchive(event) {
    const file = (event && event.srcElement && event.srcElement.files && event.srcElement.files[0]) ||
                 (event && event.target && event.target.files && event.target.files[0]);
    if (file && this.whiteListUploads(file.type)) {
      const isImage = (file.type && file.type.startsWith('image/')) || /\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name);
      if (isImage) {
        const baseName = file.name.substring(0, file.name.lastIndexOf('.')) || this.uid();
        this.fileName = `${baseName}.webp`;
        const reader = new FileReader();
        reader.onloadend = async (loadEvent: any) => {
          const webpBlob = await this.getWebPBlob(loadEvent.target.result);
          this.archive = webpBlob;
        };
        reader.readAsDataURL(file);
      } else {
        this.fileName = file.name;
        this.archive = file;
      }
    } else {
      Swal.fire({
        type: 'error',
        title: 'Erro ao carregar o arquivo.',
        text: 'Verifique se o arquivo tem o formato permitido.',
        buttonsStyling: true,
        confirmButtonClass: 'btn btn-success'
      });
    }
  }

  sendArchive() {
    let caminho = this.storeRef.child('archives/' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10) + '_' + this.fileName);
    const isWebp = this.fileName.endsWith('.webp');
    const metadata = isWebp ? { contentType: 'image/webp' } : undefined;
    let tarefa = metadata ? caminho.put(this.archive, metadata) : caminho.put(this.archive);
    tarefa.on('state_changed', (snapshot) => {
      this.percentage = Math.round((tarefa.snapshot.bytesTransferred / tarefa.snapshot.totalBytes) * 100)
    }, error => {
      // Tratar possíveis erros
    }, () => {
      if (tarefa.snapshot.state === 'success') {
        caminho.getDownloadURL().then(url => {
          this.dialogRef.close({ path: url, name: this.fileName, format: isWebp ? 'image/webp' : undefined });
        });
      }
    });
  }

  private whiteListUploads(fileType: any): boolean {
    switch (fileType) {
      case 'image/png':
        return true;
      case 'image/jpeg':
        return true;
      case 'image/jpg':
        return true;
      case 'image/gif':
        return true;
      case 'image/webp':
        return true;
      case 'image/bmp':
        return true;
      case 'application/msword':
        return true;
      case 'application/pdf':
        return true;
      case 'application/zip':
        return true;
      case 'video/x-flv':
        return true;
      case 'video/mp4':
        return true;
      case 'application/x-mpegURL':
        return true;
      case 'video/MP2T':
        return true;
      case 'video/3gpp':
        return true;
      case 'video/quicktime':
        return true;
      case 'video/x-msvideo':
        return true;
      case 'video/x-ms-wmv':
        return true;
      default:
        return false;
    }
  }

  uid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/upload/modal-multi-upload/modal-multi-upload.component.ts